import React from 'react';
import PropTypes from 'prop-types';

import { toGenericInputCreateRequest } from './formDataAdapter';
import SymantecEDR from './SymantecEDR';
import INITIAL_FORMDATA from './_initialFormData';

import { AdvancedOptionsProvider } from '../common/context/AdvancedOptions';
import { SidebarProvider } from '../common/context/Sidebar';
import { StepsProvider } from '../common/context/Steps';
import { FormDataProvider } from '../common/context/FormData';

type Props = {
  onSubmit: (InputCreateRequest) => void,
};

const EmbeddedSymantecEDRApp = ({ onSubmit }: Props) => {
  const handleSubmit = (formData) => {
    if (!onSubmit) {
      return;
    }

    onSubmit(toGenericInputCreateRequest(formData));
  };

  return (
    <StepsProvider>
      <FormDataProvider initialFormData={INITIAL_FORMDATA}>
        <SidebarProvider>
          <AdvancedOptionsProvider>
            <SymantecEDR onSubmit={handleSubmit} externalInputSubmit={typeof onSubmit === 'function'} />
          </AdvancedOptionsProvider>
        </SidebarProvider>
      </FormDataProvider>
    </StepsProvider>
  );
};

EmbeddedSymantecEDRApp.propTypes = {
  onSubmit: PropTypes.func,
};

EmbeddedSymantecEDRApp.defaultProps = {
  onSubmit: undefined,
};

export default EmbeddedSymantecEDRApp;
